import { ReactNode } from 'react';
import { colors, screen } from 'components/styles/variables';

export interface ReviewsLayoutProps {
  header?: ReactNode;
  summary: ReactNode;
  reviews: ReactNode;
  pagination: ReactNode;
}

export default function ReviewsLayout(props: ReviewsLayoutProps): JSX.Element {
  return (
    <>
      <div className="divider" />
      {props.header && <h2 className="section-header">{props.header}</h2>}
      <div className="reviews-container" id="reviews-container">
        <div className="left">{props.summary}</div>
        <div className="right">
          {props.reviews}
          <div className="pagination">{props.pagination}</div>
        </div>
      </div>

      <style jsx>{`
        .section-header {
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          color: ${colors.BLACK};
          padding-bottom: 32px;
        }
        @media screen and (max-width: 849px) {
          .section-header {
            text-align: center;
          }
        }
        @media screen and (max-width: ${screen.mdMax}) {
          .section-header {
            padding: 0 24px 24px;
          }
        }

        .reviews-container {
          display: flex;
          flex-direction: row;
        }
        @media screen and (max-width: 849px) {
          .reviews-container {
            flex-direction: column;
            align-items: center;
          }
        }
        @media screen and (min-width: ${screen.smMin}) and (max-width: ${screen.mdMax}) {
          .reviews-container {
            padding: 0 24px;
          }
          .section-header {
            padding-left: 24px;
          }
        }

        @media screen and (max-width: ${screen.xsMax}) {
          .right {
            padding: 24px 16px 0 16px;
          }
        }

        @media screen and (min-width: 850px) {
          .left {
            padding-right: 32px;
          }
        }
        @media screen and (min-width: ${screen.xsMax}) {
          .left {
            padding-bottom: 24px;
          }
        }

        .divider {
          height: 1px;
          width: 100%;
          background-color: ${colors.G2};
          margin: 52px 0 32px 0;
        }

        .pagination {
          display: flex;
          justify-content: center;
          padding: 16px 0 44px 0;
        }
      `}</style>
    </>
  );
}
